import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setAttendeeId, setSessionData } from '../redux/dataSlice';
import api from '../axiosConfig';
import generateUUID from './generateUUID';

const useFetchAttendeeData = () => {
  const dispatch = useDispatch();
  const attendeeId = useSelector((state) => state.data.attendeeId);
  const { id: sessionId } = useParams();

  const fetchAttendeeData = async () => {
    let currentAttendeeId = attendeeId;

    if (!currentAttendeeId) {
      currentAttendeeId = generateUUID();
      dispatch(setAttendeeId(currentAttendeeId));
    }

    try {
      const response = await api.get(`/attendee/loadData?sessionId=${sessionId || -1}&attendeeId=${currentAttendeeId}`);
      const data = response.data;
      dispatch(setSessionData({sessionData: data, currentQuestionIndex: data.currentQuestionIndex, attendeeSessionGroupID: data.attendeeSessionGroupID, sessionQuestions:  data.sessionQuestions, currentStep: data.sessionQuestions[data.currentQuestionIndex].step, selectedOption: data.sessionQuestions[data.currentQuestionIndex].answered, status: data.status, leaderboardData: data.leaderboardData, clientConfig: data.clientConfig}));

      return data;
    } catch (error) {
      console.error('Error fetching attendee session data:', error);
    }
  };

  return fetchAttendeeData;
};

export default useFetchAttendeeData;
